<template>
	<Modal v-model="isShow" title="账号注册">
		<Form :label-width="80" inline :model="formData" :rules="rules" ref="RegisterForm">
			<FormItem label="账号昵称" class="form-item" prop="name">
				<Input v-model="formData.name" placeholder="请输入账号昵称"></Input>
			</FormItem>
			<FormItem label="登录账号" class="form-item" prop="phone">
				<div class="flex">
					<Input class="mar-r-4" v-model="formData.phone" placeholder="请输入手机号">
					</Input>
					<Button type="primary">获取验证码</Button>
				</div>
			</FormItem>
			<FormItem label="验证码" class="form-item" prop="code">
				<Input v-model="formData.code" placeholder="请输入验证码"></Input>
			</FormItem>
			<FormItem label="登录密码" class="form-item" prop="adm_pwd">
				<Input v-model="formData.adm_pwd" placeholder="请输入登录密码"></Input>
			</FormItem>
		</Form>
	</Modal>
</template>

<script>
	export default {
		data() {
			return {
				isShow: false,
				rules: {
					name: [{
						required: true,
						message: "请输入账号昵称",
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: "请输入手机号",
						trigger: 'blur'
					}, {
						pattern: /^1[3-9]\d{9}$/,
						message: '手机号格式不正确',
						trigger: 'blur'
					}],
					adm_pwd: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},
				formData: {
					name: '',
					phone: '',
					adm_pwd: '',
					code: ''
				}
			}
		},
		methods: {
			open() {
				this.resetData()
				this.isShow = true

			},
			//清空校验结果，以及表单内容
			resetData() {
				this.$refs.RegisterForm.resetFields();
				this.formData = {
					name: '',
					phone: '',
					adm_pwd: '',
					code: ''
				}
			}
		}
	}
</script>

<style scoped>
	.flex {
		display: flex;
		align-items: center;
	}

	.mar-r-4 {
		margin-right: 4px;
	}

	.form-item {
		width: 400px;
	}
</style>